import Spin from './spin'
import Route from './route'

export default class App extends Spin {
  static Route = Route
}
